import { Injectable } from '@angular/core';
import { AcStatusSettingsExerciseType, RatingstartType } from '../models/acstatus/ac-status.type';
import { SlotModel } from '../models/slot.model';
import { GapType } from '../models/exercise.model';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() {
  }

  // SLOT HANDLING

  public static getSlotListGap(startList: Array<SlotModel>, followList: Array<SlotModel> | null = null): number {
    if (followList === null) {
      followList = [...startList];
    }
    const startData = this.getExerciseGapData(startList);
    const endData = this.getExerciseGapData(followList.reverse(), true);
    return (startData.type !== null && endData.type !== null && startData.type !== endData.type) ? Math.min(startData.amount, endData.amount) : 0;
  }

  /**
   * Checks who an how long one user type (candidate/observer) is alone at start of slot list
   *
   * @param slots Array<SlotModel>
   * @param reverse boolean
   * @param settings AcStatusSettingsExerciseType
   * @returns GapType
   */
  private static getExerciseGapData(slots: Array<SlotModel>, reverse = false): GapType {
    const parts: Array<any> = [];
    slots.forEach((slot: SlotModel) => {
      const duration = slot.duration;
      const rating_duration = slot.rating_duration;
      if (reverse === true && slot.rating_start === RatingstartType.End && slot.rating_duration > 0) {
        parts.push({
          duration: rating_duration,
          for_candidate: false,
          for_observer: true,
        });
      }
      parts.push({
        duration: duration,
        for_candidate: slot.for_candidate,
        for_observer: slot.for_observer,
      });
      if (reverse === false && slot.rating_start === RatingstartType.End && slot.rating_duration > 0) {
        parts.push({
          duration: rating_duration,
          for_candidate: false,
          for_observer: true,
        });
      }
    });
    parts.reverse();
    let amount = 0;
    let type = null;
    if (parts[0]) {
      if (parts[0].for_candidate === false || parts[0].for_observer === false) {
        type = parts[0].for_candidate === true ? 'c' : 'o';
        for (const part of parts) {
          if (
            (type === 'c' && part.for_observer === false) ||
            (type === 'o' && part.for_candidate === false)
          ) {
            amount += part.duration;
          } else {
            break;
          }
        }
      }
    }
    return {
      amount,
      type
    };
  }
}
